import { FormEvent, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import loginBG from "../assets/images/login_background.png";
import fb from "../assets/images/fb.png";
import insta from "../assets/images/insta.png";
import linkdin from "../assets/images/linkdin.png";
import yt from "../assets/images/YT.png";
import tk from "../assets/images/TT.png";
import Logo from "../components/common/Logo";
import {
  Link,
  Typography,
} from "@mui/material";
import { formFields } from "../utils/formFields";
import FormField from "../components/common/FormField";
import Validation from "../utils/Validation";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getUserAction,
  setLoginFailedResponse,
} from "../store/reducers/userSlice";
import { useSelector } from "react-redux";
import Notification from "../components/common/notification/Notification";
import { persistor } from "../store/store";
import AlertPopup from "../components/common/alertPopup/AlertPopup";

const loginFormFields = [
  formFields?.usernameOrEmail,
  formFields?.password,
  formFields?.isToLogoutAllDevices,
  formFields?.isTerminateAllSessions,
];

export default function Login() {
  const [formData, setFormData]: any = useState({});
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [openSeatModal, setOpenSeatModal] = useState(false);
  const [sessions, setSessions] = useState<any[]>([]);
  const dispatch = useDispatch();

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    usernameOrEmail: formData?.usernameOrEmail,
    password: formData?.password,
  });

  useEffect(() => {
    const fields: any = {};
    loginFormFields.map((field, index) => {
      if (
        field?.id === "isToLogoutAllDevices" ||
        field?.id === "isTerminateAllSessions"
      ) {
        fields[field?.id] = false;
      } else {
        fields[field?.id] = "";
      }
      return true;
    });
    setFormData(fields);
  }, []);

  useEffect(() => {
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userName");
    dispatch(setLoginFailedResponse(null));
    setOpenSeatModal(false);
  }, []);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };
  const navigate = useNavigate();
  const { user, loginFailedResponse } = useSelector(
    (state: any) => state?.user,
  );
  const { notification } = useSelector((state: any) => state?.mmym);
  const roles: string[] = user?.user?.role || [];

  const rolePriority = ["Owner", "Admin", "Surveyor"];
  const highestPriorityRole = rolePriority.find((role) => roles.includes(role));

  useEffect(() => {
    if (user?.idToken) {
      // Only allow redirect if is_password_change_required key exists and is false, or key does not exist
      if (
        user?.user?.email_verified === "true" &&
        (user?.user?.hasOwnProperty("is_password_change_required")
          ? user?.user?.is_password_change_required === false
          : true)
      ) {
        const nextAction = JSON.parse(
          localStorage?.getItem("nextAction") || '""',
        );
        if (user?.user?.email_verified === "true" && nextAction !== "") {
          if (nextAction === "subscribe") {
            navigate("/plans");
          } else if (nextAction === "verify_otp") {
            navigate("/account-verification");
          } else if (nextAction === "make_payment") {
            navigate("/payments");
          } else {
            navigate("/dashboard");
          }
        } else {
          if (
            roles.includes("TENANT") ||
            highestPriorityRole === "Owner" ||
            highestPriorityRole === "Admin"
          ) {
            if (user?.user?.is_new) {
              navigate("/settings");
            } else {
              navigate("/dashboard");
            }
          } else {
            navigate("/dashboard");
          }
        }
      } else {
        navigate("/activate");
      }
    } else if (user?.nextAction === "verify_otp") {
      navigate("/account-verification");
    }
  }, [user]);

  useEffect(() => {
    if (user?.nextAction === "seat_limit_exceeded") {
      setOpenSeatModal(true);
      setSessions(user?.sessions || []);
    } else if (user?.nextAction === "logout_all_devices") {
      setOpenSeatModal(true);
      setSessions([]);
    }
  }, [user]);

  useEffect(() => {
    if (loginFailedResponse?.details?.isActiveSession) {
      setOpenSeatModal(true);
      setSessions([]);
    }
  }, [loginFailedResponse]);


  // Device ID logic: store in localStorage, reuse if present, else generate new
  const getOrCreateDeviceId = () => {
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
      deviceId = `${Date.now()}-${crypto.randomUUID()}`;
      localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
  };

  // Ensure deviceId is initialized on mount so all tabs have it before login
  useEffect(() => {
    getOrCreateDeviceId();
  }, []);

  useEffect(() => {
    if (isActionCalled) {
      const payload = {
        ...formData,
        deviceId: getOrCreateDeviceId(),
      };
      if (!isError() && error !== null && isActionCalled) {
        setIsActionCalled(false);
        dispatch(getUserAction(payload));
      } else {
        setIsActionCalled(false);
      }
    }
  }, [isActionCalled]);

  const handleResetSeats = () => {
    const payload = {
      usernameOrEmail: formData.usernameOrEmail || "",
      password: formData.password || "",
      isToLogoutAllDevices: true,
      isTerminateAllSessions: false,
      deviceId: getOrCreateDeviceId(),
    };
    dispatch(getUserAction(payload));
    setOpenSeatModal(false);
    dispatch(setLoginFailedResponse(null));
  };

  const handleLogOutAnotherDevice = () => {
    const payload = {
      usernameOrEmail: formData.usernameOrEmail || "",
      password: formData.password || "",
      isToLogoutAllDevices: false,
      isTerminateAllSessions: true,
      deviceId: getOrCreateDeviceId(),
    };
    dispatch(getUserAction(payload));
    setOpenSeatModal(false);
    dispatch(setLoginFailedResponse(null));
  };

  const onChangeAction = (e: any) => {
    const id = e?.target?.id;
    const value = e?.target?.value;
    setFormData({
      ...formData,
      [id]: value,
    });
    resetValidator(e.target.id);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  const handleCloseSeatModal = () => {
    setOpenSeatModal(false);
    localStorage?.removeItem("nextAction");
    localStorage?.removeItem("user");
    setSessions([]);
    persistor.flush();
    dispatch(setLoginFailedResponse(null));
    localStorage.clear();
    localStorage.removeItem("persist:root");
  };

  return !user?.idToken ? (
    <>
      <Grid
        container
        component="main"
        sx={{
          height: "100vh",
          justifyContent: "center", // Center horizontally
          alignItems: "center", // Center vertically
          position: "relative",
          zIndex: 1, // Ensure content is above the background image
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${loginBG})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 1, // Set the opacity of the background image
            zIndex: -1, // Place the background image behind the content
          },
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          component={Paper}
          // elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Center vertically
            alignItems: "center", // Center horizontally
            width: "100%",
            "max-width": "100%",
            backgroundColor: "rgba(255, 255, 255, 0.50)",
            padding: "16px 0px",
            borderRadius: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: { xs: "0px 16px", sm: "0px" },
              width: "80%",
            }}
          >
            <Logo isTitle={true} isPosition={true} />
            <Typography
              variant="h1"
              fontWeight={600}
              align="center"
              sx={{ fontSize: { xs: "2rem", sm: "3rem" }, color: "#000000" }}
            >
              Login to your Account
            </Typography>
            <Typography
              variant="h5"
              fontWeight={600}
              sx={{ color: "#000000" }}
              mt={2}
            >
              Follow us on social media
            </Typography>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                typography: "body1",
                "& > :not(style) ~ :not(style)": {
                  ml: 1,
                },
              }}
            >
              <Link
                href="https://www.facebook.com/ManageMyMoves"
                target="_blank"
                underline="none"
              >
                <img src={fb} alt="facebook" style={{ width: "48px" }} />
              </Link>
              <Link
                href="https://www.instagram.com/managemymoves/"
                target="_blank"
                underline="none"
              >
                <img src={insta} alt="instagram" style={{ width: "64px" }} />
              </Link>
              <Link
                href="https://www.linkedin.com/company/manage-my-moves/"
                target="_blank"
                underline="none"
              >
                <img
                  src={linkdin}
                  alt="linkdin"
                  style={{ width: "48px", marginRight: "10px" }}
                />
              </Link>
              <Link
                href="https://www.youtube.com/@ManageMyMoves"
                target="_blank"
                underline="none"
              >
                <img
                  src={yt}
                  alt="youtube"
                  style={{ width: "48px", marginRight: "10px" }}
                />
              </Link>
              <Link
                href="https://www.tiktok.com/@managemymoves"
                target="_blank"
                underline="none"
              >
                <img src={tk} alt="tiktok" style={{ width: "48px" }} />
              </Link>
            </Box>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                mt: 1,
                // display: "ruby",
                // justifyContent: "center", // Center children horizontally
                // flexDirection: "column", // Align children vertically
                // alignItems: "center",
                // width: '70%'
                width: "100%",
              }}
            >
             <Notification />
              {loginFormFields?.map((field, index) => {
                return notification?.message[0] !==
                  "You have exceeded your seat limit. Please click on the check box below to logout from other devices and continue here." &&
                  (field?.id === "isToLogoutAllDevices" ||
                    field?.id === "isTerminateAllSessions") ? null : (
                  <FormField
                    {...{
                      ...field,
                      ...{
                        variant: "outlined", // Adding this variant prop
                        isRounded: true,
                        onChange: onChangeAction,
                        checkLabel: "Logout from other devices",
                        onBlur: onBlurAction,
                        error: error && error[field?.id],
                        helperText: error && error[field?.id],
                        sx: {
                          "& input:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 1000px #fff inset",
                            WebkitTextFillColor: "#000",
                            background: "transparent",
                            height: "auto !important",
                          },
                        },
                      },
                    }}
                  />
                );
              })}
              <span style={{ display: "flex", justifyContent: "flex-end" }}>
                <Link
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    textDecoration: "none",
                    fontWeight: 600,
                    marginRight: 2,
                    letterSpacing: 0.5,
                    width: "fit-content",
                  }}
                  href="/forget-password"
                >
                  Forgot Password?
                </Link>
              </span>
              <div style={{ textAlign: "center" }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    fontWeight: 600,
                    fontSize: "18px",
                    mt: 3,
                    mb: 2,
                    width: "160px", // Adjust the width as needed
                    borderRadius: "20px", // Set a border radius for rounding
                    padding: "10px 16px",
                    textTransform: "none !important",
                    backgroundColor: "#076C6B",
                    letterSpacing: 1.5,
                  }}
                >
                  Sign in
                </Button>
              </div>
            </Box>
          </Box>
          {/* <Alert severity="info" style={{marginTop:'2px'}}>Note: If you log in here, you will be automatically logged out from any other device.</Alert> */}
        </Grid>
      </Grid>

      {openSeatModal && (
        <AlertPopup
          open={openSeatModal}
          onHide={handleCloseSeatModal}
          title={
            loginFailedResponse?.details?.isActiveSession
              ? "Alert"
              : "Seat Limit Reached"
          }
          content={
            loginFailedResponse?.details?.isActiveSession ? (
              <>
                <Typography sx={{ mb: 2 }}>
                  You are currently logged in to another device: Do you wish to
                  abandon that login?
                </Typography>
              </>
            ) : (
              <>
                <Typography sx={{ mb: 2 }}>
                  Your plan allows only {user?.seatLimit} active session. Please
                  logout from all devices.
                </Typography>
                {sessions?.map((session: any) => (
                  <Box
                    key={session.session_id}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      border: "1px solid #ddd",
                      borderRadius: "5px",
                      padding: "4px 8px",
                      mb: 1,
                    }}
                  >
                    <Box>
                      <Typography>{session.user_name}</Typography>
                      <Typography variant="body2">
                        {session.user_email}
                      </Typography>
                    </Box>
                    {/* {isSeatManager && ( */}
                    {/* <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() =>
                  handleLogoutSession(session.session_id)
                }
              >
                Logout
              </Button> */}
                    {/* )} */}
                  </Box>
                ))}
              </>
            )
          }
          submitHandler={
            loginFailedResponse?.details?.isActiveSession
              ? handleLogOutAnotherDevice
              : handleResetSeats
          }
          yesText={
            loginFailedResponse?.details?.isActiveSession
              ? "Yes"
              : "Logout All Devices"
          }
        />
      )}
    </>
  ) : null;
}
